import { UseGeolocationOptions } from '@vueuse/core';

const useGeoLocation = (options: UseGeolocationOptions = {}) => {
  const { enableHighAccuracy = true, maximumAge = 30000, timeout = 27000 } = options;

  const isSupported = navigator && 'geolocation' in navigator;

  const getPosition = (): Promise<GeolocationPosition['coords']> => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        position => {
          resolve(position.coords);
        },
        err => reject(err),
        {
          enableHighAccuracy,
          maximumAge,
          timeout,
        }
      );
    });
  };

  return {
    isSupported,
    getPosition,
  };
};

export default useGeoLocation;
